import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({
    commit
  }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({
    commit
  }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({
    commit
  }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({
    commit
  }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setStatus({
    commit
  }, status) {
    commit(types.SET_STATUS, status)
  },
  setFilterBy({
    commit
  }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setBusinessChecked({ commit }, data) {
    commit(types.SET_BUSINESS_CHECKED, data)
  },
  setBusiness({
    commit
  }, data) {
    commit(types.SET_BUSINESS, data)
  },
  clearBusinesses({
    commit
  }) {
    commit(types.CLEAR_BUSINESSES)
  },
  setBusinessContacts({
    commit
  }, data) {
    commit(types.SET_BUSINESS_CONTACTS, data)
  },
  async searchBusinesses({ commit, dispatch }, search) {
    const r = await startLoading(dispatch, 'searchBusinesses', () =>
      http.post(`businessQuery/SearchBusinesses`, search)
    )
    commit(types.SET_SEARCH_BUSINESSES, r.data)
  },
  async getBusiness({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getBusiness', () =>
      http.get(`business/GetBusiness?id=${id}`)
    )
    commit(types.SET_BUSINESS, r.data)
  },
  async getBusinesses({ commit, dispatch }, searchOptions, id) {
    const r = await startLoading(dispatch, 'getBusinesses', () =>
      http.get(`businessQuery/Registered`, {
        params: searchOptions
      })
    )
    commit(types.SET_BUSINESSES, r.data)
  },
  async lookupBusiness({ commit, dispatch }, filter) {
    const r = await startLoading(dispatch, 'lookupBusiness', () =>
      http.get(`businessQuery/LocationByFilter?filter=${filter}`)
    )
    return r.data
  },
  async getBusinessContacts({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getBusinessContacts', () =>
      http.get(`businessQuery/BusinessContacts?id=${id}`)
    )
    commit(types.SET_BUSINESS_CONTACTS, r.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/businesses/actions.js